<template>
  <hs-chart-card
    :kicker="kicker"
    :title="title"
    :description="description"
    :loading="loading"
    :empty="empty"
    :min-height="minHeight"
  >
    <template v-if="$slots.actions || showDefaultControls" #actions>
      <slot name="actions">
        <hs-select
          v-if="intervalOptions.length"
          :model-value="interval"
          :options="intervalOptions"
          icon="clock"
          placeholder="Interval"
          @update:modelValue="$emit('update:interval', $event)"
        />
        <hs-select
          v-if="typeOptions.length"
          :model-value="type"
          :options="typeOptions"
          icon="bar-chart-2"
          placeholder="Metric"
          @update:modelValue="$emit('update:type', $event)"
        />
      </slot>
    </template>

    <div class="hs-analytics-panel">
      <div v-if="metrics.length" class="hs-analytics-panel__metrics">
        <hs-metric-card
          v-for="metric in metrics"
          :key="metric.label"
          :label="metric.label"
          :value="metric.value"
          :description="metric.description"
          :icon="metric.icon"
          :tone="metric.tone || 'primary'"
          :trend="metric.trend"
          :trend-direction="metric.trendDirection || 'up'"
        />
      </div>
      <div class="hs-analytics-panel__chart">
        <slot>
          <hs-line-chart
            :labels="labels"
            :datasets="datasets"
            :colors="colors"
            :currency="currency"
            :x-title="xTitle"
            :y-title="yTitle"
          />
        </slot>
      </div>
    </div>
  </hs-chart-card>
</template>

<script>
import HsChartCard from "./HsChartCard.vue";
import HsLineChart from "./HsLineChart.vue";
import HsMetricCard from "./HsMetricCard.vue";
import HsSelect from "./HsSelect.vue";

export default {
  name: "HsAnalyticsPanel",
  components: { HsChartCard, HsLineChart, HsMetricCard, HsSelect },
  props: {
    kicker: { type: String, default: "Analytics" },
    title: { type: String, required: true },
    description: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    empty: { type: Boolean, default: false },
    minHeight: { type: String, default: "420px" },
    metrics: { type: Array, default: () => [] },
    labels: { type: Array, default: () => [] },
    datasets: { type: Array, default: () => [] },
    colors: { type: Array, default: () => ["#3293ec", "#16a34a", "#f59e0b"] },
    currency: { type: String, default: "" },
    xTitle: { type: String, default: "" },
    yTitle: { type: String, default: "" },
    interval: { type: [String, Number], default: "" },
    type: { type: [String, Number], default: "" },
    intervalOptions: { type: Array, default: () => [] },
    typeOptions: { type: Array, default: () => [] },
  },
  emits: ["update:interval", "update:type"],
  computed: {
    showDefaultControls() {
      return this.intervalOptions.length || this.typeOptions.length;
    },
  },
};
</script>

<style scoped>
.hs-analytics-panel {
  display: grid;
  gap: 1rem;
}

.hs-analytics-panel__metrics {
  display: grid;
  gap: 0.8rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.hs-analytics-panel__chart {
  min-height: 310px;
}

@media (max-width: 980px) {
  .hs-analytics-panel__metrics {
    grid-template-columns: 1fr;
  }
}
</style>
